import type { Copy } from "../types";

export const pt: Copy = {
    seo: {
      title: "Calculadora de Idade do Veículo | verifique por ano e mês",
      description:
        "Verifique a idade exata de um veículo pelo ano de fabrico e mês opcional. Veja anos, meses, dias, total de dias e marcos numa ferramenta simples.",
      keywords: [
        "calculadora de idade do veículo",
        "idade do carro",
        "idade do veículo por ano",
        "ano de fabrico do carro",
        "mês de fabrico do veículo",
        "quantos anos tem o meu carro",
        "verificação da idade do veículo",
        "calculadora de idade RC",
        "calculadora de data do veículo",
        "idade do carro por mês",
        "alternativa mParivahan",
        "alternativa Parivahan",
        "calculadora de idade do veículo RTO",
        "verificar idade de registo do carro",
        "idade de registo do veículo",
      ],
      faq: [
        {
          question: "O que faz esta calculadora?",
          answer:
            "Calcula a idade exata de um veículo a partir do ano de fabrico escolhido e do mês opcional, mostrando anos, meses, dias e marcos.",
        },
        {
          question: "Por que existe um mês opcional?",
          answer:
            "O mês torna o cálculo mais preciso. Se não escolher um mês, a app usa janeiro do ano selecionado.",
        },
        {
          question: "Posso escolher um ano ou mês futuro?",
          answer:
            "Não. Os anos futuros estão bloqueados e os meses futuros ficam desativados quando o ano selecionado é o ano atual.",
        },
      ],
    },
    headerTagline: "Utilitário de veículos",
    headerTitle: "Calculadora de Idade do Veículo",
    reset: "Repor",
    switchToLight: "Mudar para modo claro",
    switchToDark: "Mudar para modo escuro",
    languageLabel: "Idioma",
    languageEnglish: "Inglês",
    languageHindi: "Hindi",
    heroEyebrow: "Idade do carro, de forma clara",
    heroTitle: "Uma ferramenta simples de data para a idade do veículo.",
    heroDescription:
      "Selecione o ano de fabrico. Adicione um mês apenas se quiser um resultado mais preciso.",
    yearSelectLabel: "Ano de fabrico",
    monthSelectLabel: "Mês de fabrico",
    includeMonthLabel: "Incluir mês específico para mais precisão",
    includeMonthNote:
      "Se não incluir um mês, será usado janeiro para o cálculo.",
    yearOnlyBadge: "Só ano",
    yearMonthBadge: "Ano + mês",
    yearPlaceholder: "Selecione o ano",
    monthPlaceholder: "Selecione o mês",
    inputTitle: "Ano de fabrico",
    inputLabel: "Ano de fabrico",
    blockedDateNote: "Os anos futuros estão bloqueados.",
    result: "Resultado",
    vehicleAgeLead: "O seu veículo está",
    asOfToday: "Até hoje",
    years: "Anos",
    months: "Meses",
    days: "Dias",
    totalDays: (count) => `${count.toLocaleString("en-IN")} dias no total`,
    ageLabels: {
      almostNew: "Quase novo",
      modern: "Moderno",
      mature: "Maduro",
      classic: "Clássico",
    },
    estimatedValue: {
      high: "Alto potencial de revenda",
      healthy: "Boa retenção de valor",
      moderate: "Depreciação moderada",
      collector: "O interesse de colecionadores pode crescer",
    },
    maintenanceTitle: "Manutenção",
    maintenance: {
      routine: "Manutenção regular e cuidado OEM",
      watch: "Acompanhe travões, fluidos e pneus",
      plan: "Planeie itens de desgaste e inspeções",
      specialized: "A manutenção especializada ganha importância",
    },
    registrationTitle: "Registo",
    registration: {
      collector: "Pode ter tratamento de colecionador em algumas regiões",
      classic: "Pode aplicar-se registo de carro clássico em algumas regiões",
      standard: "Espere renovações normais e verificações regionais",
      regular: "Geralmente aplica-se o registo normal",
    },
    upcomingMilestoneTitle: "Próximo marco",
    milestoneTimelineTitle: "Linha temporal dos marcos",
    milestoneRemaining: ({ label, days }) => `${label} em ${days.toLocaleString("pt-PT")} dias`,
    reached: "Atingido",
    upcoming: "Próximo",
    allMilestonesReachedTitle: "Todos os marcos listados foram atingidos",
    allMilestonesReachedBody:
      "Este veículo já passou a faixa de marcos mostrada na aplicação.",
    copySummary: "Copiar resumo",
    shareResult: "Partilhar resultado",
    resetMessage: "Calculadora reposta",
    summaryCopied: "Resumo copiado para a área de transferência",
    clipboardFailed: "Falha ao aceder à área de transferência",
    emptyTitle: "Escolha um ano de fabrico para ver o resumo completo",
    emptyDescription:
      "Depois de selecionar o ano, verá a idade exata, o total de dias, notas de manutenção, estado clássico e marcos.",
    shareTitle: "Calculadora de Idade do Veículo",
    summary: ({ label, years, months, days, asOf }) =>
      `O meu veículo foi fabricado em ${label} e tem ${years} anos, ${months} meses e ${days} dias em ${asOf}.`,
    milestones: {
      1: { label: "Primeiro ano", note: "Útil para garantia e planeamento de manutenção." },
      3: { label: "Três anos", note: "Momento comum para revenda e mudança de valor." },
      5: { label: "Cinco anos", note: "Boa altura para rever o orçamento de manutenção." },
      10: { label: "Dez anos", note: "Componentes mais antigos merecem atenção extra." },
      15: { label: "Quinze anos", note: "Em muitas regiões começa aqui o tratamento clássico." },
      25: { label: "Vinte e cinco anos", note: "Pode atrair colecionadores e importação em alguns mercados." },
    },
  };
